import { BaseLineSwap } from '@/app/components/icons/BaseLineSwap';
import { cn } from '@/app/utils';

export type PlanEdition = 'personal' | 'team';

interface EditionSwitcherProps {
  editionOptions?: { key: PlanEdition; label: string }[];
  edition?: PlanEdition;
  onEditionChange?: (key: PlanEdition) => void;
  className?: string;
}

/**
 * 版本切换：单按钮展示"可切换到的目标版本"，点击即切过去。
 * 仅在恰好两个选项时有意义，多于两个则按顺序轮换到下一个。
 */
export const EditionSwitcher = ({ editionOptions, edition, onEditionChange, className }: EditionSwitcherProps) => {
  if (!editionOptions?.length) return null;

  const currentIndex = editionOptions.findIndex((opt) => opt.key === edition);
  const target = editionOptions[(currentIndex + 1) % editionOptions.length];
  if (!target || target.key === edition) return null;

  return (
    <button
      type="button"
      onClick={() => onEditionChange?.(target.key)}
      className={cn(
        'flex items-center justify-center gap-2 rounded-16 bg-system-white08 px-6 py-3 font-normal text-sm text-white transition-colors hover:bg-system-white12',
        className,
      )}
    >
      <span className="whitespace-nowrap leading-[1.4]">{target.label}</span>
      <BaseLineSwap className="size-5 shrink-0" />
    </button>
  );
};
